<template>
    <div>
        <div ref="content">
            <p style="color: red;">Trainee Name: {{ traineePdf.name }}</p>
        </div>
    </div>
</template>

<script>

    import jsPDF from 'jspdf'
    import html2canvas from "html2canvas"

    export default {
        name: "trainee-pdf",
        props: ["traineePdf"],
        components: {},
        data() {
            return {}
        },
        methods: {
            downloadPdf(event) {
                const doc = new jsPDF();
                console.log(this.$refs.content)
                const contentHtml = this.$refs.content.innerHTML;
                doc.fromHTML(contentHtml, 15, 15, {
                    width: 170
                });
                doc.save("sample.pdf");
            },

            downloadWithCSS() {
                const doc = new jsPDF();
                /** WITH CSS */
                var canvasElement = document.createElement('canvas');
                html2canvas(this.$refs.content[0], { canvas: canvasElement }).then(function (canvas) {
                    doc.save("sample.pdf");
                });
            },
        }
    }
</script>

<style scoped>

</style>